export let TypeAheadAvailableNodes;

(function (TypeAheadAvailableNodes) {
  TypeAheadAvailableNodes["EMOJI"] = "emojiTypeAhead";
  TypeAheadAvailableNodes["MENTION"] = "mentionTypeAhead";
  TypeAheadAvailableNodes["QUICK_INSERT"] = "quickInsertTypeAhead";
})(TypeAheadAvailableNodes || (TypeAheadAvailableNodes = {}));

export let SelectItemMode;

(function (SelectItemMode) {
  SelectItemMode["SHIFT_ENTER"] = "shift-enter";
  SelectItemMode["ENTER"] = "enter";
  SelectItemMode["SPACE"] = "space";
  SelectItemMode["SELECTED"] = "selected";
  SelectItemMode["TAB"] = "tab";
})(SelectItemMode || (SelectItemMode = {}));